<template>
  {{ i18n(pickedUpTranslation, { date: new Date(date) }) }}
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import productReturnTranslations from './ProductReturn.translations'

const i18n = useI18n()

const props = defineProps<{
  isOneWay: boolean
  date: string
}>()

const pickedUpTranslation = computed(() =>
  props.isOneWay
    ? productReturnTranslations.shippedByCustomer
    : productReturnTranslations.backToCustomerPickUpDate,
)
</script>
